import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=09f74f02&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=09f74f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f74f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f74f02')) {
      api.createRecord('09f74f02', component.options)
    } else {
      api.reload('09f74f02', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=09f74f02&scoped=true&", function () {
      api.rerender('09f74f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/message/Message.vue"
export default component.exports